export enum AdminPanelSettingsSection {
  WORKSPACE = 'workspace',
  JOB_CREATION = 'job-creation',
}
